<template>

    <div class="menu">
        <v-tab-bar>
            <router-link :class="{ active: $route.name === 'customer-events' }" :to="{ name: 'customer-events', params: { id: customer.id } }">
                <i class="fas fa-fire mr-5"></i>
                <span>Events</span>
            </router-link>
            <router-link :class="{ active: $route.name === 'customer-traits' }" :to="{ name: 'customer-traits', params: { id: customer.id } }">
                <i class="fas fa-fingerprint mr-5"></i>
                <span>Traits</span>
            </router-link>
            <router-link :class="{ active: $route.name === 'customer-pages' }" :to="{ name: 'customer-pages', params: { id: customer.id } }">
                <i class="fas fa-globe mr-5"></i>
                <span>Pages</span>
            </router-link>
            <router-link :class="{ active: $route.name === 'customer-charges' }" :to="{ name: 'customer-charges', params: { id: customer.id } }">
                <i class="fas fa-credit-card mr-5"></i>
                <span>Charges</span>
            </router-link>
        </v-tab-bar>
        <v-button-toolbar>
            <v-button btn-style="white" size="sm" @click.native="sendEmail">
                <span><i class="icon fas fa-paper-plane mr-5"></i>Send Email</span>
            </v-button>
        </v-button-toolbar>
    </div>

</template>

<style scoped lang="scss">

    .menu {
        align-items: center;
        background: #fff;
        border-bottom: 1px solid $color-rule;
        display: flex;
        justify-content: space-between;
        padding: 10px 20px;
    }

</style>

<script>

export default {

    props: {
        customer: {
            type: Object,
            required: true,
        },
    },

    methods: {

        sendEmail() {
            if (this.customer.email) {
                window.location.href = `mailto:${this.customer.email}`;
            } else {
                this.$store.commit('setAlertError', 'The customer doesn’t have an email address.');
            }
        },

    },

}

</script>
